import { useEffect, useState, VFC } from 'react'
import { useRouter } from 'next/router'
import { UseFormRegister } from 'react-hook-form/dist/types/form'
import { ProfileEditorWrapper } from '../ProfileLayout'
import { useForm } from 'react-hook-form'
import styled from 'styled-components'
import { fontWeightRegular } from 'src/styles/font'
import { FormButtonBase, ModalDetail, Title } from '../formComponents'
import {
  _formalert,
  _profilegreen,
  safetyOrange,
  truewhite,
} from 'src/styles/colors'
import { PROFILE_SCHEDULE_URL_EXAMPLE } from 'src/assets/images'
import { MYPAGE } from 'src/utils/routes'
import { EMPTY_LOGIN_USER, LoginUser } from 'src/models/User'
import { LowerLeftMessageModal } from '../formComponents/Messages'
import { Input } from 'src/compositions/Profile/formComponents/FormInput'

const SUCCESS_MESSAGE = 'URLを更新しました。'

type ScheduleUrlFormProps = {
  user: LoginUser
  submit: (scheduleUrl: string) => Promise<any>
}

export const ScheduleUrlForm: VFC<ScheduleUrlFormProps> = ({
  user,
  submit,
}) => {
  const initialValues = user.company
  const methods = useForm<any>({
    defaultValues: initialValues,
  })
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
    setError,
  } = methods
  const id = 'scheduleUrl'
  const onSubmit = async (data: { scheduleUrl: string }) => {
    const res = await submit(data.scheduleUrl)
    if (res.error) setError(id, { message: res.error.errorMessages })
    else setModalDetail({ success: true, messages: [SUCCESS_MESSAGE] })
  }
  const router = useRouter()
  const isReady = router.isReady
  const [loading, setLoading] = useState(false)
  const [modalDetail, setModalDetail] = useState<ModalDetail>({
    success: false,
    messages: [],
  })

  useEffect(() => {
    if (!initialValues || !Object.keys(initialValues).length) return
    reset(initialValues)
  }, [initialValues, reset])

  useEffect(() => {
    if (isReady) setLoading(true)
  }, [isReady])

  if (!loading) return <></>
  if (user == EMPTY_LOGIN_USER) return <></>
  // NOTE: 特定のユーザーのみアクセス制限してrouter.pushする処理が増えたら共通化する
  if (!user.company.isActiveScheduleUrl) {
    router.push(MYPAGE)
    return <></>
  }

  return (
    <ProfileEditorWrapper user={user}>
      <Title
        title={'日程調整URL登録'}
        description={'日程調整URLを登録できます。'}
      />
      <Container>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormLabel htmlFor={id}>日程調整URL</FormLabel>
          <ScheduleUrlInput
            id={id}
            register={register}
            invalid={errors.scheduleUrl?.message}
          />
          <Messages>{errors.scheduleUrl?.message}</Messages>
          <FormSubmitDiv>
            <FormSubmitButton type="submit">設定する</FormSubmitButton>
          </FormSubmitDiv>
          <Description>
            <p>
              「つながり申請」や「メッセージ」を送信した際に、相手のメッセージ画面にあなたの日程調整URLが自動表示されます。
            </p>
            <img src={PROFILE_SCHEDULE_URL_EXAMPLE} alt="schedule_url" />
          </Description>
        </form>
      </Container>
      <LowerLeftMessageModal
        modalDetail={modalDetail}
        close={() => setModalDetail({ success: false, messages: [] })}
      />
    </ProfileEditorWrapper>
  )
}

export const ScheduleUrlInput: VFC<{
  register: UseFormRegister<any>
  id: string
  required?: true
  invalid?: boolean
}> = ({ register, id, required, invalid }) => {
  return (
    <Input
      id={id}
      placeholder={'日程調整URLを入力'}
      {...register(id, {
        required: required ? 'URLの入力に誤りがあります。' : false,
        pattern: {
          value: /https?:\/\//,
          message: 'URLの入力に誤りがあります。',
        },
      })}
      invalid={invalid}
    />
  )
}

const Container = styled.div`
  padding: 16px 10px;
  max-width: 700px;
  margin: auto;
`

const FormLabel = styled.label`
  display: inline-block;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: ${fontWeightRegular};
  text-align: left;
`

const Messages = styled.p`
  color: ${_formalert};
  margin-top: 10px;
`

const FormSubmitDiv = styled.div`
  text-align: center;
`

const FormSubmitButton = styled(FormButtonBase)`
  margin: 48px auto 70px;
  color: ${truewhite};
  background-color: ${safetyOrange};
`

const Description = styled.div`
  padding: 20px;
  border-radius: 5px;
  border: 1px solid #cdcdcd;

  p {
    font-size: 14px;
    color: #606060;
  }

  img {
    width: 100%;
    margin-top: 24px;
  }
`
